import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Popup } from 'next-common-lib';
import * as popupActions from 'redux/ducks/common/popupDucks';
import i18n from 'i18n';

export const ChangedTermsPopup = ({ contents }) => {
  const dispatch = useDispatch();
  const isShowDifferentTerms = useSelector(state => state.popup.isShowDifferentTerms);
  return (
    <>
      {isShowDifferentTerms && (
        <Popup
          id="differentTerms"
          className="popup--brity popup--change-notice"
          isShow={isShowDifferentTerms}
          isDimed={isShowDifferentTerms}
          dimedClassName="transparent"
          zIndex={3000}
          isDimedOverlap
          size="md"
          componentType="normalPopup"
          useScroll
          closeFunction={() => {
            dispatch(popupActions.closeDifferentTerms());
          }}
          headerComponent={[<h1 className="popup-title">{contents.trmsTtl}</h1>]}
          contentsComponent={[
            <>
              <div
                dangerouslySetInnerHTML={{
                  __html: contents.trmsCn,
                }}
              />
            </>,
          ]}
          bottomComponent={[
            <div className="btn-set al-right">
              <div className="btn-group">
                <Button
                  componentType="solid"
                  className="primary"
                  size="md"
                  label={i18n.t('EM_T_OK')}
                  onClick={() => {
                    dispatch(popupActions.closeDifferentTerms());
                  }}
                />
              </div>
            </div>,
          ]}
        />
      )}
    </>
  );
};
ChangedTermsPopup.propTypes = {
  contents: PropTypes.string.isRequired,
};
ChangedTermsPopup.defaultProps = {};
export default ChangedTermsPopup;
